import styled from "styled-components";

export const V3NoImportTextWrapper = styled.div`
    text-align: left;
`;